(function () {
  window.TBP = window.TBP || {};
  window.TBP.refreshKlarna = function () {
    try {
      if (window.Klarna && window.Klarna.OnsiteMessaging && typeof window.Klarna.OnsiteMessaging.refresh === 'function') {
        window.Klarna.OnsiteMessaging.refresh();
        return;
      }
    } catch (e) {}
    try {
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
    } catch (e2) {}
  };

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var GIFT_REDIRECTS = {
    'free-undies-gift': '/products/the-buttress-pillow-spandex-undies',
    'free-undies': '/products/the-buttress-pillow-spandex-undies',
    'free-spandex-undies': '/products/the-buttress-pillow-spandex-undies',
    'free-undies-gift-1': '/products/mini-butt-keychain',
    'free-keychains-gift-1': '/products/mini-butt-keychain',
    'free-keychains': '/products/mini-butt-keychain',
    'free-mini-butt-keychains': '/products/mini-butt-keychain',
    'extra-yoga-pant-cover-30-off': '/products/extra-yoga-pant-outer-cover',
    'extra-yoga-pant-cover-33-off': '/products/extra-yoga-pant-outer-cover',
    'free-2026-calendar-gift-1': '/products/2026-booty-calendar',
    'free-2026-calendar': '/products/2026-booty-calendar',
    '2026-big-booty-calendar-copy': '/products/2026-booty-calendar'
  };

  function tbpGiftDest(href) {
    if (!href) return null;
    try {
      var u = new URL(href, location.origin);
      var m = u.pathname.match(/\/products\/([^\/]+)\/?$/i);
      if (!m) return null;
      return GIFT_REDIRECTS[decodeURIComponent(m[1]).toLowerCase()] || null;
    } catch (e) {
      return null;
    }
  }

  function tbpRewriteGiftLinks(root) {
    (root || document).querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      var dest = tbpGiftDest(a.getAttribute('href'));
      if (dest) a.setAttribute('href', dest);
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var dest = tbpGiftDest(a.getAttribute('href') || a.href);
    if (!dest) return;
    e.preventDefault();
    location.assign(dest);
  }, true);

  ready(function () {
    tbpRewriteGiftLinks(document);
    if (window.MutationObserver) {
      var giftObs = new MutationObserver(function () {
        tbpRewriteGiftLinks(document);
      });
      giftObs.observe(document.documentElement, { childList: true, subtree: true });
    }

    // Hero video — desktop autoplay. Mobile keeps the red11 still (no src).
    document.querySelectorAll('[data-tbp-hero]').forEach(function (root) {
      var title = root.querySelector('.tbp-hero-v__title');
      if (title) {
        var t = (title.textContent || '').replace(/\s+/g, ' ').trim();
        if (t === 'Sleep on a Butt-Shaped Pillow' || t === 'The Original Butt Pillow') {
          title.textContent = 'Sleep on a Butt';
        }
      }
      var video = root.querySelector('video');
      if (!video) return;

      if (window.matchMedia('(max-width: 749px)').matches) {
        video.removeAttribute('src');
        video.remove();
        return;
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.remove();
        return;
      }

      var src = root.getAttribute('data-video-src');
      if (!src) return;

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.src = src;
      var show = function () { video.classList.add('is-visible'); };
      video.addEventListener('playing', show);
      video.addEventListener('loadeddata', function () {
        video.play().catch(function () {});
      }, { once: true });
      video.play().catch(function () {});
    });

    // Video lightbox — handled by tbp-product.js on PDP; homepage gallery uses same attrs.
    // Avoid double-binding play handlers here when tbp-product.js is present.
    if (!window.customElements.get('tbp-product')) {
      var modal = document.querySelector('[data-tbp-video-modal]');
      if (modal) {
        var modalVideo = modal.querySelector('video');
        var closeBtn = modal.querySelector('[data-tbp-video-close]');
        function closeModal() {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          if (modalVideo) {
            modalVideo.pause();
            modalVideo.removeAttribute('src');
            modalVideo.load();
          }
        }
        document.querySelectorAll('[data-tbp-open-video]').forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var url = btn.getAttribute('data-tbp-open-video');
            if (!url || !modalVideo) return;
            if (modal.parentElement !== document.body) {
              document.body.appendChild(modal);
            }
            modalVideo.setAttribute('playsinline', '');
            modalVideo.setAttribute('webkit-playsinline', '');
            modalVideo.controls = true;
            modalVideo.src = url;
            modalVideo.load();
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            var playModal = function () {
              modalVideo.play().catch(function () {});
            };
            window.requestAnimationFrame(function () {
              window.requestAnimationFrame(function () {
                if (modalVideo.readyState >= 2) playModal();
                else modalVideo.addEventListener('loadeddata', playModal, { once: true });
              });
            });
          });
        });
        if (closeBtn) closeBtn.addEventListener('click', closeModal);
        modal.addEventListener('click', function (e) {
          if (e.target === modal) closeModal();
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeModal();
        });
      }
    }

    // Quiz
    document.querySelectorAll('[data-tbp-quiz]').forEach(function (root) {
      var answers = {};
      var stepEls = root.querySelectorAll('[data-quiz-step]');
      var resultEl = root.querySelector('[data-quiz-result]');
      var bar = root.querySelector('[data-quiz-bar]');
      var titleEl = root.querySelector('[data-quiz-result-title]');
      var reasonEl = root.querySelector('[data-quiz-result-reason]');
      var cta = root.querySelector('[data-quiz-cta]');
      var productUrl =
        root.getAttribute('data-product-url') ||
        '/products/thebuttresspillow?view=buttress-pillow';
      var copy = {
        odb: {
          title: 'ODB — Classic bubble (M)',
          reason: 'Compact and best for small to medium builds. Perfect for first-time butt sleepers looking to experience our signature Buttress feel.'
        },
        omg: {
          title: 'OMG — Bold & curvy (L)',
          reason: 'Curvaceous, cheeky and versatile. Well balanced for sleep and everyday comfort. Best for small to medium builds.'
        },
        ort: {
          title: 'ORT — Thicc & supportive (XL)',
          reason: 'Thick thighs, full hourglass, the most sleeping surface. Best for medium-to-large builds and side and back sleepers.'
        }
      };

      function score() {
        var s = { odb: 0, omg: 0, ort: 0 };
        if (answers.vibe === 'classic') s.odb += 3;
        if (answers.vibe === 'thicc') s.ort += 3;
        if (answers.booty === 'compact') s.odb += 4;
        if (answers.booty === 'maximum') s.ort += 4;
        // Bold and balanced are the same middle vote, counted once.
        if (answers.vibe === 'bold' && answers.booty === 'balanced') s.omg += 4;
        else {
          if (answers.vibe === 'bold') s.omg += 3;
          if (answers.booty === 'balanced') s.omg += 4;
        }
        if (answers.sleep === 'stomach') s.odb += 8;
        if (answers.sleep === 'side' || answers.sleep === 'back') {
          if (answers.booty === 'compact') s.odb += 2;
          else s.ort += 8;
        }
        // Rotators need more surface. ORT, unless they asked for compact.
        if (answers.sleep === 'rotate') {
          if (answers.booty === 'compact') s.omg += 2;
          else s.ort += 8;
        }
        return ['odb', 'omg', 'ort'].reduce(function (best, id) {
          return s[id] > s[best] ? id : best;
        });
      }

      function fitLine(model) {
        if (answers.sleep === 'stomach') {
          return 'Stomach sleepers do best on the ODB — small to medium builds. ';
        }
        if ((answers.sleep === 'side' || answers.sleep === 'back') && model === 'ort') {
          return 'Side and back sleepers do best on the ORT — medium-to-large builds. ';
        }
        if (answers.sleep === 'rotate' && model === 'ort') {
          return 'If you move around, the ORT gives you the most sleeping surface. ';
        }
        if (model === 'odb' || model === 'omg') {
          return 'A good match for small to medium builds. ';
        }
        return '';
      }

      function showStep(i) {
        stepEls.forEach(function (el, idx) {
          el.classList.toggle('is-hidden', idx !== i);
        });
        if (bar) bar.style.width = ((i + 1) / stepEls.length) * 100 + '%';
      }

      root.querySelectorAll('[data-quiz-opt]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = btn.getAttribute('data-quiz-step-id');
          var value = btn.getAttribute('data-quiz-opt');
          answers[step] = value;
          var current = parseInt(btn.closest('[data-quiz-step]').getAttribute('data-quiz-step'), 10);
          if (current < stepEls.length - 1) {
            showStep(current + 1);
            return;
          }
          var model = score();
          var meta = copy[model];
          stepEls.forEach(function (el) { el.classList.add('is-hidden'); });
          if (resultEl) resultEl.classList.add('is-visible');
          if (titleEl) titleEl.textContent = meta.title;
          if (reasonEl) reasonEl.textContent = fitLine(model) + meta.reason;
          if (cta) {
            try {
              var dest = new URL(productUrl, window.location.origin);
              if (!dest.searchParams.get('view')) {
                dest.searchParams.set('view', 'buttress-pillow');
              }
              dest.searchParams.set('model', model);
              cta.href = dest.pathname + dest.search;
            } catch (e) {
              cta.href =
                '/products/thebuttresspillow?view=buttress-pillow&model=' + model;
            }
          }
          if (bar) bar.style.width = '100%';
        });
      });

      var restart = root.querySelector('[data-quiz-restart]');
      if (restart) {
        restart.addEventListener('click', function () {
          answers = {};
          if (resultEl) resultEl.classList.remove('is-visible');
          showStep(0);
        });
      }

      showStep(0);
    });

    // Exclusive FAQ accordion (homepage + shared)
    document.querySelectorAll('[data-tbp-faq]').forEach(function (root) {
      var items = root.querySelectorAll('[data-tbp-faq-item]');
      items.forEach(function (item) {
        var btn = item.querySelector('.tbp-faq__trigger');
        var panel = item.querySelector('.tbp-faq__panel');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var wasOpen = item.classList.contains('is-open');
          items.forEach(function (other) {
            other.classList.remove('is-open');
            var ob = other.querySelector('.tbp-faq__trigger');
            var op = other.querySelector('.tbp-faq__panel');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (op) op.hidden = true;
          });
          if (!wasOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    });

    // Exclusive FAQ for PDP story <details>
    document.querySelectorAll('.tbp-story__faq').forEach(function (root) {
      root.querySelectorAll('details').forEach(function (detail) {
        detail.addEventListener('toggle', function () {
          if (!detail.open) return;
          root.querySelectorAll('details').forEach(function (other) {
            if (other !== detail) other.open = false;
          });
        });
      });
    });

    // Mobile header menu (skip if the header already bound its own toggle)
    document.querySelectorAll('[data-tbp-header]').forEach(function (header) {
      if (header.dataset.tbpMenuBound === '1') return;
      var btn = header.querySelector('[data-tbp-menu-toggle]');
      var drawer = header.querySelector('[data-tbp-menu-drawer]');
      if (!btn || !drawer) return;
      header.dataset.tbpMenuBound = '1';
      btn.addEventListener('click', function () {
        var open = drawer.hasAttribute('hidden');
        if (open) {
          drawer.removeAttribute('hidden');
          btn.setAttribute('aria-expanded', 'true');
          btn.setAttribute('aria-label', 'Close menu');
        } else {
          drawer.setAttribute('hidden', '');
          btn.setAttribute('aria-expanded', 'false');
          btn.setAttribute('aria-label', 'Open menu');
        }
      });
    });

    // UGC paged gallery (match Next snap + dots)
    document.querySelectorAll('[data-tbp-ugc-slider]').forEach(function (root) {
      root.querySelectorAll('[data-tbp-ugc-track]').forEach(function (track) {
        var viewport = track.closest('.tbp-ugc-slider__viewport');
        var dots = viewport ? viewport.querySelectorAll('[data-tbp-ugc-dot]') : [];
        var more = viewport ? viewport.querySelector('[data-tbp-ugc-more]') : null;
        var pageCount = track.querySelectorAll('.tbp-ugc-slider__page').length;

        function sync() {
          if (!track.clientWidth) return;
          var page = Math.round(track.scrollLeft / track.clientWidth);
          page = Math.max(0, Math.min(page, pageCount - 1));
          dots.forEach(function (dot, i) {
            var on = i === page;
            dot.classList.toggle('is-active', on);
            dot.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          if (more) {
            var canScroll = track.scrollLeft + track.clientWidth < track.scrollWidth - 8;
            if (canScroll && page < pageCount - 1) more.removeAttribute('hidden');
            else more.setAttribute('hidden', '');
          }
        }

        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        sync();

        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            var index = parseInt(dot.getAttribute('data-tbp-ugc-dot'), 10) || 0;
            track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
          });
        });
      });
    });

    // Gallery page lightbox
    document.querySelectorAll('[data-tbp-lightbox]').forEach(function (modal) {
      var img = modal.querySelector('[data-tbp-lightbox-img]');
      function close() {
        modal.setAttribute('hidden', '');
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (img) img.removeAttribute('src');
      }
      function open(src) {
        if (!img || !src) return;
        img.src = src;
        modal.removeAttribute('hidden');
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }
      document.querySelectorAll('[data-tbp-lightbox-open]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          open(btn.getAttribute('data-tbp-lightbox-open'));
        });
      });
      modal.querySelectorAll('[data-tbp-lightbox-close]').forEach(function (btn) {
        btn.addEventListener('click', close);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !modal.hasAttribute('hidden')) close();
      });
    });
  });
})();
